
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import component
import { DateToDateSearchComponent } from './components/date-to-date-search/date-to-date-search.component'
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonGroupComponent, FormModule } from '@coreui/angular';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [DateToDateSearchComponent],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        ButtonGroupComponent,
        FormModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [DateToDateSearchComponent],
    providers: []
})


export class SharedCoreModule { }